// extracted by mini-css-extract-plugin
module.exports = {"weekList":"UpcomingDaysForecast_weekList__3DYk_"};